<app-page-header [header]="getPageHeader()" [showBackButton]="false" />
<app-hospital-availability-search />
<p-confirmDialog key="hospitalAvailabilitySavedMsg" [style]="{ width: '700px' }"></p-confirmDialog>
